var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showPhotoMessage || _vm.message.self)?_c('div',[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.message.content.photoLarge}})]):_c('div',[_c('div',{staticClass:"overflow-hidden"},[_c('img',{staticClass:"img-fluid message-photo-blur",attrs:{"src":_vm.message.content.photoLarge}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }